<!-- 仓库管理页面 -->
<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      tableName="warehouseInfo"
      exportDataUrl="/warehouse/selectWarehouse"
      @onSearch="handleSearch"
    >
      <template #funBtn>
        <el-row :gutter="8">
          <el-col :span="1.5">
            <el-button type="primary"  icon="Plus" @click="handleAdd" v-hasPermi="['basicData::warehouseInfo::add']"
              >新增</el-button
            >
          </el-col>
        </el-row>
      </template>
    </Table>
    <AddUpdate
      v-model="addUpdateOpen"
      :data="addUpdateData"
      :title="addUpdateTitle"
      @success="handleSuccess"
    />
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import AddUpdate from "./addUpdate";
import { ref } from "vue";
import { listWarehouse, deleteWarehouse } from "@/api/warehouse/warehouse";
import { getCustomTableCols } from "@/tableColumn";
import { confirmBoxFun } from "@/utils/msgBox";

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "warehouseInfo",
});

const tableData = ref([]);
const tableRef = ref(null);

const total = ref(0);
const loading = ref(false);
const addUpdateData = ref({});
const addUpdateOpen = ref(false);
const addUpdateTitle = ref("新增");

// 搜索
const handleSearch = (data) => {
  loading.value = true;
  listWarehouse(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};

const handleAdd = () => {
  addUpdateTitle.value = "新增";
  addUpdateData.value = {};
  addUpdateOpen.value = true;
};

// 修改
const handleUpdate = (event, row) => {
  addUpdateTitle.value = "修改";
  addUpdateData.value = row;
  addUpdateOpen.value = true;
};

const handleSuccess = () => {
  tableRef.value.onSearch();
};

const handleDelete = (event, row) => {
  confirmBoxFun(() => {
    deleteWarehouse(row.warehouseId)
      .then((res) => {
        tableRef.value.onSearch();
      })
      .catch((res) => {});
  }, "是否确定要删除此仓库？");
};

const columns = getCustomTableCols([
  "warehouseName",
  "warehouseCode",
  "warehouseAddress",
  "createTime",
  "operatorName",
  "operateTime",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "修改",
        controlType: "success",
        controlText: true,
        controlPermission: ["basicData::warehouseInfo::update"],
        controlFun: handleUpdate,
      },
      {
        control: "button",
        controlName: "删除",
        controlType: "danger",
        controlText: true,
        controlPermission: ["basicData::warehouseInfo::delete"],
        controlFun: handleDelete,
      },
    ],
  },
]);
</script>

<style lang="scss" scoped></style>
